import i18next from 'i18next';
import React from 'react';

import Text, { ENUM_COLORS } from '@commons/Text';

import { Container, AvatarContainer, MessageContainer, TypingDots, Icon } from './styledComponents';
import AgentIcon from './components/AgentIcon';

const TypingIndicator = () => (
  <Container>
    <AvatarContainer>
      <Icon>
        <AgentIcon />
      </Icon>
    </AvatarContainer>
    <MessageContainer>
      <Text color={ENUM_COLORS.DGREY}>{i18next.t('AGENT.AGENT.THINKING_MESSAGE')}</Text>
      <TypingDots>
        <span></span>
        <span></span>
        <span></span>
      </TypingDots>
    </MessageContainer>
  </Container>
);

export default TypingIndicator;
